import { ActionReducer } from '@ngrx/store';

import { AppStateInterface } from 'app/core/app-config/state/models/app-state.interface';

export function traceLogReducer(reducer: ActionReducer<AppStateInterface>): ActionReducer<AppStateInterface> {
  return function (state: AppStateInterface, action: any): AppStateInterface {
   // console.groupCollapsed('App state');
    console.groupEnd();

    return reducer(state, action);
  };
}

